var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransitionCloud22(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 829 837",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648 60C648 93.1371 621.137 120 588 120H304C270.863 120 244 93.1371 244 60C244 26.8629 270.863 0 304 0H588C621.137 0 648 26.8629 648 60ZM615 477C648.137 477 675 450.137 675 417C675 383.863 648.137 357 615 357H182C148.863 357 122 383.863 122 417C122 450.137 148.863 477 182 477H393.001C410.578 477 424.827 490.431 424.827 507C424.827 523.569 410.578 537 393.001 537H60C26.8629 537 0 563.863 0 597C0 630.137 26.8629 657 60 657H219.001C236.578 657 250.827 670.431 250.827 687C250.827 703.569 236.578 717 219.001 717H148C114.863 717 88 743.863 88 777C88 810.137 114.863 837 148 837H593C626.137 837 653 810.137 653 777C653 743.863 626.137 717 593 717L515.942 717C499.401 716.968 486.001 703.549 486.001 687C486.001 670.431 499.432 657 516.001 657H769C802.137 657 829 630.137 829 597C829 563.863 802.137 537 769 537L581.942 537C565.401 536.968 552.001 523.549 552.001 507C552.001 490.431 565.432 477 582.001 477H615Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransitionCloud22);
export default __webpack_public_path__ + "static/media/transition_cloud_2_2.3c0935a54c9021164a2e29bfe53ab659.svg";
export { ForwardRef as ReactComponent };